<template>
    <aside class="menu">
        <h4 class="menu-label">
            <router-link :to="menudata.Url" v-if="menudata.Url">{{menudata.Name}}</router-link>
            <div v-if="!menudata.Url">{{menudata.Name}}</div>
        </h4>
        <ul class="menu-list">
            <li v-for="menuItem in menudata.Children" :key="menuItem.url" v-if="!menuItem.Hide">
                <router-link :to="menuItem.Url" :class="{'is-active':isActive(menuItem)}">{{menuItem.Name}}</router-link>
                <ul v-if="menuItem.Children.length>0 && isSubActive(menuItem)">
                    <li v-for="subMenuItem in menuItem.Children" v-if="!subMenuItem.Hide">
                        <router-link :to="subMenuItem.Url" :class="{'is-active':isActive(subMenuItem)}">{{subMenuItem.Name}}</router-link>
                    </li>    
                </ul>
            </li>
        </ul>

        <div class="mt-4" v-if="recordedWidth">
            <div ref="indhold" v-if="sidemenuIndhold" v-html="sidemenuIndhold" />
            <!-- <div v-else>
                <h5 class="mt-4">Følg os på instagram</h5>
                <iframe src="https://snapwidget.com/embed/672232" class="snapwidget-widget" allowtransparency="true" frameborder="0" scrolling="no" style="border:none; overflow:hidden; width:100%; "></iframe>
            </div> -->
        </div>
    </aside>
</template>

<script>
export default {
    props:["menudata", "currentId", "sidemenuIndhold"],
    data(){
        return{
            recordedWidth : 0
        }
    },
    mounted(){
        this.recordedWidth = this.$el.offsetWidth;
        this.$nextTick(()=>{
            var iframes = this.$el.querySelectorAll("iframe");
            for(var i=0;i<iframes.length;i++)
            {
                var ratio = iframes[i].offsetHeight / iframes[i].offsetWidth;
                iframes[i].style.width = this.recordedWidth + "px";
                iframes[i].style.height = (this.recordedWidth*ratio) + "px";
            }
        })
    },
    methods:
    {
        isActive(menuItem){
            return menuItem.Id == this.currentId
        },
        isSubActive(menuItem){
            var isActive = this.isActive(menuItem);
            menuItem.Children.map(c=>isActive |= this.isActive(c));
            return isActive;
        }
    },
    created(){
        let snapWidgetScript = document.createElement('script');
        snapWidgetScript.setAttribute('src', 'https://snapwidget.com/js/snapwidget.js');
        // snapWidgetScript.setAttribute('crossorigin', 'anonymous');
        document.head.appendChild(snapWidgetScript);
    }
}
</script>

<style lang="scss" scoped>¨
    .menu-label
    {
        border-top:1px solid #cdcdcd;
        border-bottom:1px solid #cdcdcd;
        padding:6px 0;
    }
    ul{
        list-style:none;
        margin:0;
        padding:0;
        li{
            padding:7px 0;
            border-bottom: solid 1px #cdcdcd;
            li{
                padding-left:24px;
                border-bottom:none;
            }
        }
    }
    .is-active{
        font-weight:bold;
        background-color:unset !important;
        color:unset !important;
    }
</style>
